<script>
    import { navigateTo } from 'svelte-router-spa'
    import { residence } from '../../store.js'

    function nxt() {
        residence.set($residence)
        navigateTo('cellphone')
    }
</script>

<main>
    <div class="body">
        <h1>Enter your residential address</h1>
        <p>Ilagay ang address ng iyong tirahan</p>
        <textarea bind:value={$residence} rows="4"></textarea>

        {#if $residence}
        <a class="btn btn-primary" on:click={nxt}>Next</a>
        {/if}
    </div>
</main>